import { useQuery } from '@tanstack/react-query';
import portalApi from 'utils/portalApi';

const getProjectActivities = async (projectId) => {
    const { data } = await portalApi.get(`api/activities?projectId=${projectId}`);
    return data;
};

const useProjectActivities = (projectId) => {
    const { data, refetch, isLoading } = useQuery({
        queryKey: ['projectActivities', projectId],
        queryFn: () => getProjectActivities(projectId)
    });

    return { data, refetch, isLoading };
};

export default useProjectActivities;
